import { render, staticRenderFns } from "./LocationFormGroup.vue?vue&type=template&id=241e7397"
import script from "./LocationFormGroup.vue?vue&type=script&lang=ts"
export * from "./LocationFormGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports